import Privacy from '@/views/Privacy/index.vue'

const PrivacyRouter = {
  path: '/privacy',
  name: 'Privacy',
  component: Privacy,
  props: (route) => ({
    secret: route.query.secret,
    token: route.query.token
  })
}

export default PrivacyRouter
